// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Bj71","newExpiryDate":"styles_newExpiryDate__31ATk","footer":"styles_footer__165R4"};